/**
 * export uri dùng đẻ call API
 */
export const uriAPIConsts = {

  chat: {
    FACEBOOK: {
      SUBSCRIBE_APP: '/chat/facebook/subscribedapp',
      GET_TOKEN_INFO: '/chat/facebook/gettokeninfo',
    }
  },
  user: {
    OUT_PAGE: '/business/page/outpages'
  },
  login: {
    LIST_PAGE: '/business/page/pagelist', // lấy danh sách page khi login
    LOAD_MORE_PAGE_META: '/business/page/loadmorepagemeta',
    USER_JOIN_PAGES: '/business/page/joinpages',
    NEW_PAGES: '/business/page/newpages',
    ADD_PAGES: '/business/page/addpages'
  },
  notification: {
    SUBSCRIBE_TO_TOPICS: '/notification/subscribetotopics',
    UNSUBSCRIBE_FROM_ALL_TOPICS: '/notification/unsubscribefromalltopics'
  },
  business: {
    SETTING2: '/business/index/setting2'
  }
}
